import {User} from "domain-models"

export type UserState = User

type UserAction = {
  type: string
  user: User
}

const initialState = {
  ...window.app.user
}
const userReducer = (state: UserState = initialState, action: UserAction) => {
  switch (action.type) {
    case 'UPDATE_USER':
      return {
        ...state,
        ...action.user
      }
    default:
      return state
  }
}

export default userReducer
